import React from 'react';
export function Footer() {
  return <footer className="border-t border-champagne bg-cream px-4 py-8 text-center" data-id="element-111" data-mp="32wd2cf6gdjt0">
      <p className="text-sm text-cocoa" data-id="element-112" data-mp="3gg118925080a">
        © 2026 Pastry Instructor Ready — All rights reserved.
      </p>
    </footer>;
}